import { Model } from 'es6/components/model'
import { roundFloatPointNum } from 'helpers/number-helpers'

/**
 * Модель для скидки в корзине.
 */
export class Discount extends Model {
  /**
   * Текущее состояние товаров для акции
   * @returns {number} цена/количество товаров для акции
   */
  getCurrent () {
    let currentState = this.get('accumulateSum') || this.get('accumulateQty')
    return currentState || 0
  }

  /**
   * Процент выполнения условия акции
   * @returns {number} процент
   */
  getPercent () {
    let start = this.getStart(),
      all = this.getEnd() - start,
      current = this.getCurrent() - start
    return (current / all) * 100
  }

  /**
   * Количество/цена набранных товаров в корзине для акции
   * @returns {number} количество/цена
   */
  getStart () {
    let currentStep = this.get('currentStep')
    if (currentStep) {
      return currentStep.sum_range ? currentStep.sum_range.from : currentStep.qty_range.from
    }
    return 0
  }

  /**
   * Общее количество/цена товаров необходимые для выполнения условий акции
   * @returns {number} количество/цена
   */
  getEnd () {
    let currentStep = this.get('currentStep')
    if (currentStep) {
      return currentStep.sum_range ? currentStep.sum_range.to : currentStep.qty_range.to
    }
    return 0
  }

  /**
   * Количество/цена товаров оставшееся для выполнения условий акции
   * @returns {number} количество/цена
   */
  getRest () {
    let end = this.getEnd(),
      current = this.getCurrent()
    return roundFloatPointNum(end - current)
  }
}
